import { Fragment } from "react";
import "./spinner-loading.css";

export default function SpinnerLoading({
    isSpinning
}){
    if(isSpinning){
        return (
            <Fragment>
                <svg className='spinner'></svg>
            </Fragment>
        );
    } else {
        return (
            <Fragment>
    
            </Fragment>
        );
    }

}